module.exports = __webpack_public_path__ + "media/categories/1065-cd9e492f.svg";